import { R as C } from "./components/core/RiksTV-DwRmJooI.mjs";
import { S as F } from "./components/core/Strim-DzoD2YI9.mjs";
import { L as D } from "./components/core/LightMode-DENdo5SC.mjs";
import { G as k } from "./components/spacing/Gutter-CZQOVELR.mjs";
import { G as N } from "./components/spacing/GutterPadding-Dm0Wv0tj.mjs";
import { N as Q } from "./components/notificationDot/NotificationDot-C24-oy5e.mjs";
import { A as _ } from "./components/accordion/Accordion-CrPiD_81.mjs";
import { P as U } from "./components/panel/Panel-DJ4o_gTQ.mjs";
import { A as z } from "./components/alert/Alert-C3DRURBA.mjs";
import { B as K, a as X } from "./components/breadcrumb/Breadcrumb-ou16wYBD.mjs";
import { P as Z } from "./components/progress/Progress-ZSILwF-g.mjs";
import { L as re } from "./components/loader/Loader-Bk0JZ1M5.mjs";
import { C as ne } from "./components/progress/CircularProgress-Cwu3B7Wu.mjs";
import { D as se } from "./components/dropdown/Dropdown-iW7aS3jx.mjs";
import { G as ae, P as ce, S as ue, T as de } from "./components/button/Button-Bs_Tl8uJ.mjs";
import { G as fe, P as le, S as xe, T as ge } from "./components/button/ArrowButton-C0WywcBN.mjs";
import { G as ye, P as Te, S as ve, T as Be } from "./components/button/IconButton-3TUWI6Mc.mjs";
import { T as we } from "./components/toggleButton/ToggleButton-Cnjgoc3g.mjs";
import { T as Ie } from "./components/toggleInlineButton/ToggleInlineButton-BR5pxqVE.mjs";
import { T as be } from "./components/toggleLinkButton/ToggleLinkButton-4Aji3dk9.mjs";
import { C as Pe } from "./components/checkbox/Checkbox-D6f5jfzl.mjs";
import { R as Se } from "./components/toggle/RadioToggle-BICr1hFE.mjs";
import { F as Ce } from "./components/toggle/FieldSet-Bq2lhIzg.mjs";
import { T as Fe } from "./components/textfield/TextField-L5Yijkyt.mjs";
import { P as De } from "./components/textfield/PasswordTextField-Du9g2_M9.mjs";
import { B as ke, d as Ve, D as Ne, a as $e, b as Qe, c as We, H as _e, L as qe, M as Ue, S as je, e as ze, f as Je, g as Ke, T as Xe } from "./components/typography/Typography-qfbU_T11.mjs";
import { L as Ze } from "./components/list/List-CpfjceLN.mjs";
import { C as rr } from "./components/list/CheckmarkListItem-DUrrtCnH.mjs";
import { L as nr } from "./components/list/ListItem-JIUBy2_m.mjs";
import { C as sr } from "./components/list/CrossmarkListItem-CN9Ovufg.mjs";
import { O as ar } from "./components/list/OrderedListItem-CmneHG3P.mjs";
import { useState as x, useEffect as m, useRef as c, useCallback as g, useLayoutEffect as y } from "react";
import { I as ur } from "./components/icons/Icons-De2TWMGd.mjs";
import { B as mr } from "./components/button/BaseLinkButton-CquLmqew.mjs";
const h = "(prefers-reduced-motion: reduce)", T = (e) => typeof window < "u" && window.matchMedia ? window.matchMedia(e).matches : !1, v = (e, t) => {
  typeof e.addEventListener < "u" && e.addEventListener("change", t);
}, B = () => {
  const [e, t] = x(T(h));
  return m(() => {
    typeof window < "u" && window.matchMedia && v(window.matchMedia(h), (n) => {
      t(n.matches);
    });
  }, []), { prefersReducedMotion: e };
};
function b(e, t) {
  const n = c(), s = c(), o = c(null), a = c(!0), { prefersReducedMotion: u } = B();
  function d(r) {
    var l;
    const i = o.current;
    i && r.target === i && (i.removeAttribute("style"), (l = t == null ? void 0 : t.onTransitionEnd) == null || l.call(t, e));
  }
  const f = g(() => {
    var i, l;
    if (a.current)
      return;
    if ((i = t == null ? void 0 : t.onTransitionStart) == null || i.call(t, e), u) {
      (l = t == null ? void 0 : t.onTransitionEnd) == null || l.call(t, e);
      return;
    }
    const r = o.current;
    if (r)
      if (r.style.display = "block", r.style.overflow = "hidden", e)
        r.style.height = "0", r.style.height = `${r.scrollHeight}px`;
      else {
        if (r.scrollHeight === 0) {
          r.removeAttribute("style");
          return;
        }
        r.style.height = `${r.scrollHeight}px`, n.current = requestAnimationFrame(() => {
          s.current = requestAnimationFrame(() => {
            r.style.height = "0px";
          });
        });
      }
  }, [e, t, u]);
  return y(() => {
    f();
  }, [e, f]), m(() => {
    const r = o.current;
    return r && r.addEventListener("transitionend", d), () => {
      r && r.removeEventListener("transitionend", d);
    };
  }, [e]), m(() => {
    const r = n.current, i = s.current;
    return a.current = !1, () => {
      r && cancelAnimationFrame(r), i && cancelAnimationFrame(i);
    };
  }, [n, s]), [o, f];
}
const M = ({ ref: e, callback: t, condition: n = !0 }) => {
  const s = g(
    (o) => {
      e != null && e.current && !e.current.contains(o.target) && t(o);
    },
    [t, e]
  );
  m(() => (e && n && document && document.addEventListener("click", s), () => {
    document && document.removeEventListener("click", s);
  }), [e, n, s]);
}, p = (() => {
  const e = globalThis.IntersectionObserverEntry;
  return "IntersectionObserver" in globalThis && e && "isIntersecting" in e.prototype;
})(), w = () => {
}, L = (e, t = {}, n = w, s = !0) => {
  const [o, a] = x(null), u = g((r) => a(r), [a]), d = c(t), f = c(null);
  return m(() => {
    if (!p) {
      n == null || n();
      return;
    }
    let r = f.current;
    return r == null || r.disconnect(), o && s && (r = new IntersectionObserver(e, d.current), r.observe(o)), () => {
      r == null || r.disconnect();
    };
  }, [o, e, n, s]), [u];
}, P = (e = { rootMargin: "150px" }, t = !0) => {
  const [n, s] = x(!1), [o] = L(
    (a) => {
      const u = a.some((d) => d.isIntersecting);
      s(u);
    },
    e,
    void 0,
    t
  );
  return [o, n];
}, I = () => typeof window < "u" && typeof MutationObserver < "u", R = (e, t, n) => {
  const s = c(n);
  m(() => {
    if (I() && e) {
      const o = new MutationObserver(t);
      return "current" in e ? e.current && o.observe(e.current, s.current) : o.observe(e, s.current), () => o.disconnect();
    }
  }, [e, t]);
};
export {
  _ as Accordion,
  z as Alert,
  mr as BaseLinkButton,
  ke as Body,
  Ve as Bold,
  K as Breadcrumb,
  X as BreadcrumbCurrent,
  Pe as Checkbox,
  rr as CheckmarkListItem,
  ne as CircularProgress,
  sr as CrossmarkListItem,
  Ne as DisplayTitle,
  se as Dropdown,
  Ce as FieldSet,
  fe as GhostArrowButton,
  ae as GhostButton,
  ye as GhostIconButton,
  k as Gutter,
  N as GutterPadding,
  $e as H1,
  Qe as H2,
  We as H3,
  _e as H4,
  ur as Icons,
  qe as Lead,
  D as LightMode,
  Ze as List,
  nr as ListItem,
  re as Loader,
  Ue as Meta,
  Q as NotificationDot,
  ar as OrderedListItem,
  U as Panel,
  De as PasswordTextField,
  le as PrimaryArrowButton,
  ce as PrimaryButton,
  Te as PrimaryIconButton,
  Z as Progress,
  Se as RadioToggleInput,
  C as RiksTVProvider,
  xe as SecondaryArrowButton,
  ue as SecondaryButton,
  ve as SecondaryIconButton,
  je as Span,
  F as StrimProvider,
  ze as SubBody,
  Je as SubTitle2,
  Ke as SubTitle3,
  Xe as Tag,
  ge as TertiaryArrowButton,
  de as TertiaryButton,
  Be as TertiaryIconButton,
  Fe as TextField,
  we as ToggleButton,
  Ie as ToggleInlineButton,
  be as ToggleLinkButton,
  b as useAnimatedHeight,
  B as useBrowserPreferences,
  M as useClickOutsideListener,
  P as useElementVisible,
  L as useIntersectionObserver,
  R as useMutationObserver
};
